import { render, staticRenderFns } from "./ConsentToUseRecords.vue?vue&type=template&id=53ddb996&scoped=true"
import script from "./ConsentToUseRecords.vue?vue&type=script&lang=js"
export * from "./ConsentToUseRecords.vue?vue&type=script&lang=js"
import style0 from "./ConsentToUseRecords.vue?vue&type=style&index=0&id=53ddb996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ddb996",
  null
  
)

export default component.exports